import { render, staticRenderFns } from "./Administracion.vue?vue&type=template&id=42582b2c&scoped=true&"
import script from "./Administracion.vue?vue&type=script&lang=js&"
export * from "./Administracion.vue?vue&type=script&lang=js&"
import style0 from "./Administracion.vue?vue&type=style&index=0&id=42582b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42582b2c",
  null
  
)

export default component.exports